/**
 * Supported locales. Kept in sync with the saas-auth
 * `app.i18n.supported-locales` setting (en/es/fr/pt today). Offering anything
 * outside this set to PATCH /api/account/locale returns 400 INVALID_LOCALE.
 */
export const SUPPORTED_LOCALES = ['en', 'es', 'fr', 'pt'] as const;

export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

export const DEFAULT_LOCALE: SupportedLocale = 'en';

export function isSupportedLocale(value: unknown): value is SupportedLocale {
  return typeof value === 'string' && (SUPPORTED_LOCALES as readonly string[]).includes(value);
}

export function normalizeLocale(input: string | null | undefined): SupportedLocale | null {
  if (!input) return null;
  const primary = input.toLowerCase().split(/[-_]/)[0];
  if (!primary) return null;
  return isSupportedLocale(primary) ? primary : null;
}
